import { TableException } from "./TableException";

export class LockedTableException extends TableException {

    constructor () {
        super("O garçom ou operador está editando seu pedido no momento. Por favor, aguarde 1 minuto e tente novamente. Se o problema continuar, chame o garçom para assistência");
    }

    get variables () {
        return {}
    }

    get template () {
        return "lockedTableException";
    }
    
}
